import SectionHead from "./SectionHead";
import { rankingList, risingSide } from "@/mocks/cgua";

export default function Ranking() {
  const medal = (rank: number) =>
    rank <= 3
      ? "bg-primary-500 text-background-50"
      : "bg-background-100 text-foreground-600";

  return (
    <section id="paihang" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          no="01"
          eyebrow="17吃瓜排行"
          title="人气热榜 · 本小时速更"
          desc="按讨论热度与换榜频次实时滚动，TOP 列表每十分钟重排一次。"
          linkLabel="查看完整排行"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* 榜单主体 */}
          <div className="lg:col-span-8 rounded-xl border border-background-200 bg-background-100 overflow-hidden">
            <ul className="divide-y divide-background-200">
              {rankingList.map((r) => (
                <li key={r.rank}>
                  <a
                    href="#"
                    className="group flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3 hover:bg-background-50 transition-colors cursor-pointer"
                  >
                    <span
                      className={
                        "flex items-center justify-center w-7 h-7 shrink-0 rounded-md font-heading text-sm font-bold " +
                        medal(r.rank)
                      }
                    >
                      {r.rank}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-sm md:text-[15px] font-semibold text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors truncate">
                        {r.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-1 whitespace-nowrap">
                          <i className="ri-fire-line text-primary-400" />
                          {r.heat}
                        </span>
                        <span className="hidden sm:inline text-background-300">|</span>
                        <span className="hidden sm:inline text-foreground-500">{r.tag}</span>
                      </span>
                    </span>
                    <span className="shrink-0 text-xs text-foreground-500 hidden sm:block">
                      {r.delta === "up" && <span className="text-accent-700">▲ 上升</span>}
                      {r.delta === "down" && <span className="text-foreground-400">▼ 下滑</span>}
                      {r.delta === "new" && (
                        <span className="text-primary-600 font-semibold">新上榜</span>
                      )}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 右侧：上升中的瓜 + 快捷索引 */}
          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="rounded-xl bg-accent-500/10 border border-accent-200 p-4 md:p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-950 mb-3">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-accent-500 text-foreground-950">
                  <i className="ri-arrow-up-line text-[13px]" />
                </span>
                正在上升
              </h3>
              <ul className="space-y-2.5">
                {risingSide.map((s, i) => (
                  <li key={i}>
                    <a
                      href="#"
                      className="group flex items-start gap-2.5 cursor-pointer"
                    >
                      <span className="mt-1.5 w-1.5 h-1.5 shrink-0 rounded-full bg-accent-600" />
                      <span className="flex-1 min-w-0">
                        <span className="block text-sm text-foreground-800 leading-snug group-hover:text-accent-900 transition-colors">
                          {s.title}
                        </span>
                        <span className="text-xs text-foreground-500">{s.tag}</span>
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-xl bg-primary-500 text-background-50 p-4 md:p-5">
              <h3 className="flex items-center gap-2 text-sm font-bold mb-3">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-background-50 text-primary-600">
                  <i className="ri-folder-transfer-line text-[13px]" />
                </span>
                换榜速报
              </h3>
              <p className="text-sm leading-relaxed opacity-90">
                今日热榜已完成 5 次换榜，神反转与考古类话题涨幅最快，适合直接点进对应合集一次看全。
              </p>
              <a
                href="#heji"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold bg-background-50 text-primary-700 rounded-full px-3.5 py-1.5 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-list-check-3" />
                去合集里追
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}